import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { IDefaultCard } from '../Cards/DefaultCard'
import BaseDetail from './BaseDetail'


export default function YetiSummerCollectionDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IDefaultCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri.replace('http:', 'https:')).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTDescription() {
    return (
      <div>
        YetiSwap Summer Collection
        <p>
          It is a special series of NFT which is limited only to 300 NFTs, created with 6 different types and 3
          different color options, created by Yetiswap especially for the summer of 2021.
        </p>
      </div>
    )
  }

  return (
    <BaseDetail
      {...props}
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={detailTokenItem ? detailTokenItem.attributes : []}
      externalUrl={detailTokenItem ? `https://ipfs.io/ipfs/${detailTokenItem.externalUrl}` : ''}
      description={getNFTDescription()}
    >
      {detailTokenItem ? (
        <img src={`https://ipfs.io/ipfs/${detailTokenItem.image}`} alt={detailTokenItem.name} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
